class Challenge  {
    constructor(data) {
        this.category = new Object();
        this.oponent = new Object();
        this.bet = new Object();
    }
}